export const PAYMENT_METHODS = [
  { title: 'Credit', name: 'card', icon: 'credit-card-multiple.svg' },
  { title: 'Bank', name: 'bank_account', icon: 'bank-outline.svg' },
  { title: 'Apple', name: 'apple', icon: 'apple.svg' },
  { title: 'PayPal', name: 'paypal', icon: 'paypal.png' },
  { title: 'Google', name: 'google', icon: 'google.png' },
]
